import { useCallback } from "react";
import {
  createCampaign,
  deleteCampaign,
  getCampaignById,
  getCampaignDashboard,
  listCampaigns,
  updateCampaign,
} from "../service/CallCenterCampaigns";
import { useAsyncAction } from "./useAsyncAction";

export const useCampaigns = () => {
  const state = useAsyncAction([]);

  const create = useCallback(
    async (payload) => state.run(() => createCampaign(payload)),
    [state]
  );
  const update = useCallback(
    async (campaignId, payload) => state.run(() => updateCampaign(campaignId, payload)),
    [state]
  );
  const remove = useCallback(
    async (campaignId) => state.run(() => deleteCampaign(campaignId)),
    [state]
  );
  const getById = useCallback(
    async (campaignId) => state.run(() => getCampaignById(campaignId)),
    [state]
  );
  const getDashboard = useCallback(
    async () => state.run(() => getCampaignDashboard()),
    [state]
  );
  const list = useCallback(async () => state.run(() => listCampaigns()), [state]);

  return {
    ...state,
    create,
    update,
    remove,
    getById,
    getDashboard,
    list,
  };
};
